import { Const } from './constants';

export abstract class Ng2TableDefault {
  // Config de la tabla:
  rows: Array<any> = [];
  data: Array<any> = [];
  config: any = {};
  // Config del paginador:
  page: number;
  pagination = Const.PAGINATION;
  itemsPerPage: number;
  numPages: number;
  length: number;

  private _columns: Array<any> = [];

  set columns(v: Array<any>) {
    this.config.sorting = { columns: v };
    this._columns = v;
  }
  get columns() {
    return this._columns;
  }

  constructor() {
    this.init();
  }

  /**
   * Actualiza propiedades de la clase para resolver problema de herencia en JS.
   * Más info: https://stackoverflow.com/questions/43595943
   *
   * @memberof Ng2TableDefault
   */
  init() {
    this.columns = [];
    this.config = {
      paging: true,
      filtering: { filterString: '' },
      className: ['table-striped', 'table-bordered']
    };
    this.page = 1;
    this.numPages = 1;
    this.itemsPerPage = this.pagination.itemsPerPage;
    this.length = 0;
  }

  /**
   * Se ejecuta al cambiar la página cuando se pagina la data.
   *
   * @param {*} page
   * @param {Array<any>} [data=this.data]
   * @returns {Array<any>}
   * @memberof Ng2TableDefault
   */
  changePage(page: any, data: Array<any> = this.data): Array<any> {
    const start = (page.page - 1) * page.itemsPerPage;
    const end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  /**
   * Ordena la data con respecto a una columna.
   *
   * @param {*} data
   * @param {*} config
   * @returns {*}
   * @memberof Ng2TableDefault
   */
  changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    const columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].hasOwnProperty('sort') && (columns[i].sort !== '' && columns[i].sort !== false)) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  /**
   * Para realizar el filtro por columna.
   *
   * @param {*} data
   * @param {*} config
   * @returns {*}
   * @memberof Ng2TableDefault
   */
  changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          if (!item[column.name]) {
            item[column.name] = '';
          }
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString)
      );
    }

    const tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  /**
   * Punto de entrada para configurar e iniciar la tabla.
   *
   * @param {*} config
   * @param {*} [page={ page: this.page, itemsPerPage: this.itemsPerPage }]
   * @returns {*}
   * @memberof Ng2TableDefault
   */
  async onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }) {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    const filteredData = await this.changeFilter(this.data, this.config);
    const sortedData = await this.changeSort(filteredData, this.config);
    this.rows = await page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  /**
   * Setea el total de páginas calculado por el paginador.
   *
   * @param {number} n
   * @memberof Ng2TableDefault
   */
  async setNumPages(n: number) {
    this.numPages = await n;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/util/ng2-table-default.ts